import { SupportAgent } from "@mui/icons-material";
import { Box, Stack, Typography, List, ListItem, ListItemText } from "@mui/material";
import React from "react";
import NutriAIBotIcon from '../assets/nai_bot.png'

// Helper function to parse and format the message
const formatMessage = (message) => {
  // Split the message by new lines
  const lines = message.split("\n").map((line) => line.trim()).filter(line => line !== "");

  return lines.map((line, index) => {
    // Handle bold text (e.g., **bold**)
    const formattedText = line.split(/\*\*(.*?)\*\*/g).map((part, i) =>
      i % 2 === 1 ? (
        <span key={i} style={{ fontWeight: "bold" }}>
          {part}
        </span>
      ) : (
        part
      )
    );

    // Handle ordered lists (e.g., "1. Item")
    if (/^\d+\.\s/.test(line)) {
      return (
        <List key={index}>
          <ListItem sx={{ paddingLeft: 1 }}>
            <ListItemText primary={formattedText} />
          </ListItem>
        </List>
      );
    }

    // Handle unordered lists (e.g., "- Item" or "* Item")
    if (/^[-*]\s/.test(line)) {
      return (
        <List key={index}>
          <ListItem sx={{ paddingLeft: 1 }}>
            <ListItemText primary={formattedText} />
          </ListItem>
        </List>
      );
    }

    // Default text with reduced spacing between paragraphs
    return (
      <Typography key={index} variant="body1" sx={{ marginBottom: 0.5 }}>
        {formattedText}
      </Typography>
    );
  });
};

// BotChatCard component
function BotChatCard({ message }) {
  return (
    <Stack direction="row" spacing={2} m={2} alignItems="flex-start">
      {/* Bot Icon */}
      <img src={NutriAIBotIcon} style={{ width: '30px', height: '30px' }}/>

      {/* Message Content */}
      <Box
        sx={{
          // Additional styling if needed
        }}
      >
        {formatMessage(message)}
      </Box>
    </Stack>
  );
}

export default BotChatCard;
